export default __webpack_public_path__ + "static/media/O_right.58a350da.png";